import React, { useContext } from 'react';
import { Link, Typography } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import useSiteData from '../../hooks/useSiteData';
import OrderConfirmationPanel from './OrderConfirmationPanel';
import useIdentityContext from '../../hooks/useIdentityContext';
import { SourcePageContext } from '../contexts/SourcePageContext';
import useShopperProfile from '../../hooks/useShopperProfile';
import { OrderDetailsContext } from '../contexts/OrderDetailsContext';

const Headline = () => {
  const [orderDetailsMessages] = useTranslations(['orderDetailsMessages']);
  const { externalAppNavigation: nav } = useSiteData();
  const orderHistoryUrl = nav.orderHistory;
  const { identity } = useIdentityContext();
  const { isAnonymousUser } = identity;
  const { isConfirmationPage: showConfirmation } =
    useContext(SourcePageContext);
  const profile = useShopperProfile();
  const { order } = useContext(OrderDetailsContext);

  // if anon, email is on the order, else get email from profile
  const email = (isAnonymousUser ? order?.emailAddress : profile?.email) || '';

  if (showConfirmation) {
    return <OrderConfirmationPanel email={email} />;
  }

  return (
    <>
      {!isAnonymousUser && orderHistoryUrl && (
        <Link href={orderHistoryUrl} mb={5}>
          {orderDetailsMessages.orderHistoryLinkText}
        </Link>
      )}
      {/* This aria hidden heading is intended for those viewing the visual UI
and is hidden from assistive tech to prevent redundancy 
since we also render a visually hidden heading at the top of the page */}
      <Typography
        mb={5}
        fontSize="x4large"
        fontWeight="bold"
        aria-hidden
        data-testid="order-details-heading"
      >
        {orderDetailsMessages.titleMessage}
      </Typography>
      <Typography fontWeight="bold">{email}</Typography>
    </>
  );
};

export default Headline;
